export default {
  'ticket.operator': 'اپراتور',
  'ticket.status': 'وضعیت',
  'ticket.ticketid': 'شماره درخواست',
  'ticket.subject': 'موضوع',
  'ticket.lastupdate': 'آخرین بروزرسانی',
  'ticket.total': 'همه درخواست ها',
  'ticket.notassigned': 'تیم پشتیبانی تریپسی',
  'ticket.addnewticket': 'درخواست جدید',
  'ticket.search': 'جستجو',
  'ticket.myticket': 'درخواست های من',
  'ticket.knowleadgebase': 'دانش محور',
  'ticket.announcements': 'اطلاعیه ها',
  'ticket.description': 'توضیحات',
  'ticket.findtickets': 'جستجو درخواست',
  'ticket.send': 'ارسال',
  'ticket.mytickets': 'درخواست های من',
  'ticket.close': 'بستن',
  'ticket.knowledgebase': 'دانشنامه',
  'ticket.all': 'همه',
  'ticket.done': 'انجام شده',
  'ticket.inprogress': 'در حال انجام',
  'ticket.new': 'جدید',
  'ticket.ticketsInbox': 'صندوق ورودی',
  'ticket.ticketsUnread': 'خوانده نشده',
  'ticket.sender': 'فرستنده',
  'ticket.newticket': 'درخواست جدید',
  'ticket.close': 'بستن',
  'ticket.uploadYourImage': 'پیوست عکس',
  'ticket.ticketType': 'نوع درخواست',
  'ticket.indertSuccessFully': 'درخواست شما با موفقیت ارسال شد',
  'ticket.text': 'متن',
  'ticket.insertSubject': 'لطفا موضوع درخواست خود را وارد کنید',
  'ticket.insertText': 'لطفا متن درخواست خود را وارد کنید',
  'ticket.insertMessageAndSubject': 'لطفا موضوع و متن درخواست خود را وارد کنید',
  'ticket.item': 'مورد',
  'ticket.submitinwriting': 'ارسال کتبی',
  'ticket.dateoforder': 'تاریخ سفارش',
  'ticket.dateoftravel': 'تاریخ سفر',

  'ticket.flight': 'پرواز',
  'ticket.details': 'جزئیات',
  'ticket.responseaverage': 'میانگین پاسخگویی',
  'ticket.supportnum': 'تعداد پشتیبانی',
  'ticket.support': 'پشتیبانی تریپسی',
  'ticket.minutes': 'دقیقه',
  'ticket.reply': 'پاسخ',
  'ticket.supervisor': 'مسئول',
  'ticket.attachment': 'پیوست',
  'ticket.preview': 'پیش نمایش',

  'ticket.title': 'عنوان',
  'ticket.createddate': 'تاریخ ثبت',
  'ticket.ticketNumber': 'شماره تیکت',
  'ticket.message': 'متن',
  'ticket.lastanswerdate': 'آخرین جواب',
  'ticket.attachphoto':
    'در این قسمت از بخش درخواست میتوانید عکس مورد نظر خود را از طریق لینک زیر بارگزاری کنید .',
};
